(() => {
  var App = (() => {
    var initialize = () => {
      CartOrderDateApp.init()
      VideoMuteControlWrapperApp.init()
      ConnectedProductPickerApp.init()
      DemensionSizeDataApp.init()
      TabApp.init()
      ProductItemApp.init()
      ProductInfoCollapseWrapperApp.init()
      DeliveryDatePicker.init()
      PageHeading2SliderFunc.init()
			headerMenuActiveFunc.init()
      sectionGardenHouseFunc.init();
      SitePopupApp.init();
      LinkToGardenShedProductsElementDurationFunc.init();
      ProductColorOptionSwatchApp.init();
      SalesCountdownTimerFunc.init();
      // OfferCommunicationHandleCartFunc.init();
      MontageserviceProductAddToCartApp.init();
    }
    return {
      init: initialize
    }
  })()

  document.addEventListener('DOMContentLoaded', () => {
    App.init()
  })
  
  var MontageserviceProductAddToCartApp = (() => {
    function getSectionIds() {
      const cartMini = document.querySelector('xo-cart-mini');
      const cartMiniId = cartMini ? cartMini.id : null;
      if (cartMiniId) return [cartMiniId, 'cart-icon-bubble'];
      return ['cart-drawer', 'cart-icon-bubble'];
    }

    // Update theme cart store so mini-cart and header icon refresh (same as adding a normal product)
    function pushCartSections(sections, itemCount) {
      if (typeof window.xoStore !== 'undefined' && sections && Object.keys(sections).length) {
        window.xoStore.set('xo-cart', function(prev) {
          return Object.assign({}, prev, { sections: sections, size: itemCount != null ? (prev.size || 0) + itemCount : (prev.size || 0) + 1 });
        })('xo-cart/updateCartSections');
      }
    }

    async function fetchCart() {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return res.json();
    }

    var initialize = () => {
      const sectionIds = getSectionIds();
      const addToCartBtn = document.querySelector('.mon-ATC-button');
      const variantId = document.querySelector('#montageservice-product-variant-id')?.value;
      console.log("Here is the offer communication function......1", variantId, parseInt(variantId));
      if (!addToCartBtn || !variantId) return;
      
      let is_productAdded = false;
      addToCartBtn.addEventListener('click', async (e) => {
        if (is_productAdded) return; // prevent duplicate calls
        
        is_productAdded = true;
        // await new Promise(resolve => setTimeout(resolve, 1200));
        const items = [
          {
            id: parseInt(variantId),
            quantity: 1,
            properties: {
              _is_montageservice: true  // optional: flag it as a gift for reference
            }
          }
        ];
        try {
          const cart = await fetchCart();
          console.log('Cart items variant_ids:', cart.items.map(i => i.variant_id), typeof cart.items[0]?.variant_id);
          console.log('variantId:', variantId, typeof variantId);
          const alreadyInCart = cart.items.some(item =>
            item.properties?._is_montageservice === true
          );

          if (alreadyInCart) {
            console.log('Montageservice product is already in cart — skipping.');
            document.querySelector(".xo-menu-hamburger__action-cart[xo-name='cart']").click();
            return;
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: items,
              sections: sectionIds,
              section_url: window.location.pathname
            }),
          });

          if (!res.ok) throw new Error('HTTP ' + res.status);
          const cartData = await res.json();
          if (cartData.sections) pushCartSections(cartData.sections, items.length);
          // 3. Trigger cart update (dispatch event for your xo-cart-add component)
          document.dispatchEvent(new CustomEvent('cart:updated'));
          
          document.querySelector(".xo-menu-hamburger__action-cart[xo-name='cart']").click();
          console.log('Montageservice product is added.');
        } catch (err) {
          console.error('Error adding to cart:', err);
        } finally {
          is_productAdded = false;
        }
      });
    }
    return {
      init: initialize
    }
  })();

  var ProductColorOptionSwatchApp = (() => {
    var initialize = () => {
      document.querySelectorAll('[js-container] [js-product-color-option]').forEach(element => {
        element.addEventListener('click', () => {
          element.closest('[js-container]').querySelectorAll('[js-product-color-option]').forEach(subelement => {
            subelement.classList.remove('active');
          });
          element.classList.add('active');
          element.closest('[js-container]').querySelectorAll('[js-product-featured-image]').forEach(image => {
            if (image.getAttribute('js-product-featured-image') === element.getAttribute('js-product-color-option')) {
              image.classList.remove('d-none');
            } else {
              image.classList.add('d-none');
            }
          });
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var LinkToGardenShedProductsElementDurationFunc = (() => {
    var initialize = () => {
      document.querySelectorAll('a[href^="#garden_shed_products"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
          e.preventDefault();

          var target = document.querySelector(this.getAttribute('href'));
          if (!target) return;

          var targetPosition = target.getBoundingClientRect().top + window.scrollY;
          var startPosition = window.scrollY;
          var distance = targetPosition - startPosition;
          var duration = 500; // 0.3s
          var startTime = null;

          function ease(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; // easeInOut
          }

          function step(currentTime) {
            if (!startTime) startTime = currentTime;
            var elapsed = currentTime - startTime;
            var progress = Math.min(elapsed / duration, 1);

            window.scrollTo(0, startPosition + distance * ease(progress));

            if (elapsed < duration) requestAnimationFrame(step);
          }

          requestAnimationFrame(step);
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var OfferCommunicationHandleCartFunc = (() => {
    var isActiveTimer = () => {
      const endTime = document.querySelector(".scb-countdown-timer")?.dataset.endTime;
      var now = new Date().getTime();
      var end = new Date(endTime).getTime();

      return (now < end);
    }
    function getSectionIds() {
      const cartMini = document.querySelector('xo-cart-mini');
      const cartMiniId = cartMini ? cartMini.id : null;
      if (cartMiniId) return [cartMiniId, 'cart-icon-bubble'];
      return ['cart-drawer', 'cart-icon-bubble'];
    }

    // Update theme cart store so mini-cart and header icon refresh (same as adding a normal product)
    function pushCartSections(sections, itemCount) {
      if (typeof window.xoStore !== 'undefined' && sections && Object.keys(sections).length) {
        window.xoStore.set('xo-cart', function(prev) {
          return Object.assign({}, prev, { sections: sections, size: itemCount != null ? (prev.size || 0) + itemCount : (prev.size || 0) + 1 });
        })('xo-cart/updateCartSections');
      }
    }

    async function fetchCart() {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return res.json();
    }

    async function removeCartItem(key, sectionIds) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: 0,
          sections: sectionIds,
          section_url: window.location.pathname,
        }),
      });
      if (!res.ok) return;
      const data = await res.json();
      if (data.sections) pushCartSections(data.sections, -1);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    var initialize = () => {
      const sectionIds = getSectionIds();
      const addToCartBtn = document.querySelector('.shopify-product-form xo-cart-add button');
      const freeVariantId = document.querySelector('#free-product-variant-id')?.value;

      // Get the main product's ID so we can track it in the cart.
      const mainProductId = parseInt(
        document.querySelector('.shopify-product-form [data-product-id]')?.dataset.productId ||
        document.querySelector('[data-section-type="product"] [name="id"]')?.closest('[data-product-id]')?.dataset.productId
      );
      
      let removingFreeGift = false;

      async function checkAndRemoveFreeGift() {
        if (removingFreeGift) return;

        try {
          const cart = await fetchCart();

          const freeGiftItem = cart.items.find(
            item => String(item.variant_id) === String(freeVariantId)
          );
          if (!freeGiftItem) return; // free gift not in cart, nothing to do

          const mainProductStillInCart = cart.items.some(
            item => String(item.variant_id) !== String(freeVariantId)
          );

          if (!mainProductStillInCart) {
            removingFreeGift = true;
            await removeCartItem(freeGiftItem.key, sectionIds);
          }
        } catch (err) {
          console.error('Error checking/removing free gift:', err);
        } finally {
          removingFreeGift = false;
        }
      }
      
      if (addToCartBtn && parseInt(freeVariantId) && isActiveTimer()) {
        
        let freeGiftAdding = false;
        addToCartBtn.addEventListener('click', async (e) => {
          if (freeGiftAdding) return; // prevent duplicate calls
          
          freeGiftAdding = true;
          await new Promise(resolve => setTimeout(resolve, 1200));

          const items = [
                  {
                    id: parseInt(freeVariantId),
                    quantity: 1,
                    properties: {
                      _free_gift: true  // optional: flag it as a gift for reference
                    }
                  }
                ];
          try {
            const cart = await fetchCart();
            const alreadyInCart = cart.items.some(
              item => String(item.variant_id) === String(freeVariantId)
            );

            if (alreadyInCart) {
              console.log('Free gift already in cart — skipping.');
              return;
            }

            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: items,
                sections: sectionIds,
                section_url: window.location.pathname
              }),
            });

            if (!res.ok) throw new Error('HTTP ' + res.status);
            const cartData = await res.json();
            if (cartData.sections) pushCartSections(cartData.sections, items.length);
            // 3. Trigger cart update (dispatch event for your xo-cart-add component)
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } catch (err) {
            console.error('Error adding to cart:', err);
          } finally {
            freeGiftAdding = false;
          }
        });

        // Watch the cart scroll container for removed xo-product nodes
        const cartScrollEl = document.querySelector('xo-cart-scroll');
        if (cartScrollEl) {
          const observer = new MutationObserver((mutations) => {
            const hadRemoval = mutations.some(m => m.removedNodes.length > 0);
            if (hadRemoval) {
              checkAndRemoveFreeGift();
            }
          });

          observer.observe(cartScrollEl, { childList: true, subtree: true });
        } else {
          console.warn('xo-cart-scroll not found — observer not attached');
        }
      }
      if (parseInt(freeVariantId) && !isActiveTimer()) {
        // Watch the cart scroll container for removed xo-product nodes
        const cartScrollEl = document.querySelector('xo-cart-scroll');
        if (cartScrollEl) {
          const observer = new MutationObserver((mutations) => {
            const hadRemoval = mutations.some(m => m.removedNodes.length > 0);
            if (hadRemoval) {
              checkAndRemoveFreeGift();
            }
          });

          observer.observe(cartScrollEl, { childList: true, subtree: true });
        } else {
          console.warn('xo-cart-scroll not found — observer not attached');
        }
      }
    }
    return {
      init: initialize
    }
  })()

  var SalesCountdownTimerFunc = (endDate => {
    var pad = n => String(n).padStart(2, '0')

    var elements = {
      days: document.getElementById('scb-days'),
      hours: document.getElementById('scb-hours'),
      minutes: document.getElementById('scb-minutes'),
      seconds: document.getElementById('scb-seconds'),
    }

    var update = () => {
      var now = new Date().getTime()
      var end = new Date(endDate).getTime()

      if (isNaN(end)) {
        console.log("Invalid end date:-----------", endDate)
        return;
      }
      var diff = end - now

      if (diff <= 0) {
        elements.days.textContent = '00'
        elements.hours.textContent = '00'
        elements.minutes.textContent = '00'
        elements.seconds.textContent = '00'

        document.querySelector('.sales-countdown-banner').style.display = 'none';
        document.querySelector('.xo-product-info-content__price').style.display = 'block';
        return
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24))
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = Math.floor((diff % (1000 * 60)) / 1000)

      elements.days.textContent = pad(days)
      elements.hours.textContent = pad(hours)
      elements.minutes.textContent = pad(minutes)
      elements.seconds.textContent = pad(seconds)
    }

    var initialize = () => {
      if (!elements.days || !elements.hours || !elements.minutes || !elements.seconds) return
      update()
      setInterval(update, 1000)
    }

    return { 
      init: initialize 
    }
  })(window.SCB_END_DATE || '')

  var SitePopupApp = (() => {
    var initialize = () => {
      document.querySelectorAll('[js-site-popup]').forEach(container => {
        let delay = parseInt(container.getAttribute('data-delay'))
        if (isNaN(delay)) delay = 0
        setTimeout(() => {
          container.classList.add('open')
        }, delay)
        container.querySelectorAll('[js-close]').forEach(element => {
          element.addEventListener('click', () => {
            container.classList.remove('open')
          })
        })
      })
    }
    return {
      init: initialize
    }
  })()

  let sectionGardenHouseFunc = (() => {
    let initialize = () => {
      const setMaxHeightClass = () => {
        const gardenSection = document.querySelector(
          '.video-guide-section-wrapper'
        )
        if (!gardenSection) return

        const rect = gardenSection.getBoundingClientRect()
        const distanceFromViewportTop = rect.top
        const hiddenEle = document.querySelector('.gh-block--product-image')
        if (!hiddenEle) return

        if (distanceFromViewportTop < 0) {
          hiddenEle.classList.add('max-height-set')
        } else {
          hiddenEle.classList.remove('max-height-set')
        }
      }

      window.addEventListener('scroll', setMaxHeightClass)

      const videoElement = document.querySelector(
        '.video-guide-section-wrapper .video-wrapper video'
      )
      const videoWrapper = document.querySelector(
        '.video-guide-section-wrapper .video-wrapper'
      )
      const playButton = document.querySelector(
        '.video-guide-section-wrapper .video-button'
      )
      if (!videoElement || !videoWrapper || !playButton) return

      // You can then use the isVideoPlaying variable elsewhere in your code
      videoElement.addEventListener('play', () => {
        playButton.style.display = 'none'
      })
      videoElement.addEventListener('pause', () => {
        playButton.style.display = 'flex'
      })
      videoElement.addEventListener('ended', () => {
        videoElement.play()
        videoElement.pause()
      })

      videoWrapper.addEventListener('click', () => {
        if (!videoElement.paused) {
          videoElement.pause()
        } else {
          videoElement.play()
        }
      })
    }
    return {
      init: initialize
    }
  })()

  let headerMenuActiveFunc = (() => {
    let initialize = () => {
      document.addEventListener('click', e => {
        document
          .querySelectorAll(
            '.xo-menu-horizontal__item.xo-menu-horizontal__item--first:has(.xo-menu-horizontal__sub-menu)'
          )
          .forEach(element => {
            element.classList.remove('active')
          })
        if (
          e.target.closest(
            '.xo-menu-horizontal__item.xo-menu-horizontal__item--first:has(.xo-menu-horizontal__sub-menu)'
          )
        ) {
          const element = e.target.closest(
            '.xo-menu-horizontal__item.xo-menu-horizontal__item--first:has(.xo-menu-horizontal__sub-menu)'
          )
          element.classList.add('active')
        }
      })
    }
    return {
      init: initialize
    }
  })()
  var PageHeading2SliderFunc = (() => {
    var initialize = () => {
      document
        .querySelectorAll('[js-page-heading-2-description-slider]')
        .forEach(element => {
          new Flickity(element, {
            prevNextButtons: false,
            adaptiveHeight: false,
            wrapAround: false,
            pageDots: false,
            contain: true,
            imagesLoaded: true,
            cellAlign: 'left'
          })
        })
    }
    return {
      init: initialize
    }
  })()

  var DeliveryDatePicker = (() => {
    const EMPTY_DATE_VALUE = 'mm/dd/yyyy'

    Date.prototype.getWeek = function () {
      var date = new Date(this.getTime())
      date.setHours(0, 0, 0, 0)
      // Set the date to the nearest Thursday (decides the year and week number).
      date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7))
      // Get the first day of the year for this new date.
      var week1 = new Date(date.getFullYear(), 0, 4)
      // Calculate the number of weeks between the target date and week1.
      return (
        1 +
        Math.ceil(
          ((date.getTime() - week1.getTime()) / 86400000 -
            3 +
            ((week1.getDay() + 6) % 7)) /
            7
        )
      )
    }

    async function fetchCart () {
      const res = await fetch('/cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' }
      })
      if (!res.ok) throw new Error('Failed to fetch cart')
      return res.json()
    }

    async function setLineProperties (lineKey, properties) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          properties: properties
        })
      })

      if (!res.ok) {
        const text = await res.text().catch(() => '')
        throw new Error(`Failed to update line (${lineKey}): ${text}`)
      }
      return res.json()
    }

    async function applyPropertyToAllLines (propertyName, propertyValue) {
      const cart = await fetchCart()
      const lines = cart.items || []

      const propPatch = { [propertyName]: propertyValue }

      for (const line of lines) {
        const merged = { ...(line.properties || {}), ...propPatch }
        await setLineProperties(line.key, merged)
      }
    }

    function getDateInputValue () {
      let result = null
      const dateInput = document.getElementById('cart_delivery_time')
      if (dateInput && dateInput.value !== EMPTY_DATE_VALUE) {
        const [month, day, year] = String(dateInput.value).split('/')
        const attr_name = dateInput.getAttribute('data-attribute-name')
        const attr_value = `${day}.${month}.${year}`
        result = [attr_name, attr_value]
      }
      return result
    }

    function findFirstEnabledDate (
      fp,
      startDate = new Date(),
      maxDaysAhead = 60
    ) {
      // flatpickr uses midnight dates; normalize to avoid timezone weirdness
      const d = new Date(startDate)
      d.setHours(0, 0, 0, 0)

      for (let i = 0; i <= maxDaysAhead; i++) {
        const candidate = new Date(d)
        candidate.setDate(d.getDate() + i)

        // flatpickr considers "disabled" if any disable rule returns true
        const isDisabled = fp.isEnabled(candidate) === false
        if (!isDisabled) return candidate
      }
      return null
    }

    function disableUnavailableDates (input) {
      if (!input || typeof flatpickr !== 'function') return null

      const targetElement = input.closest(
        '.xo-cart-mini-drawer-footer__date-picker--wrapper'
      )

      if (!targetElement) return null

      const element = flatpickr(input, {
        enableTime: false,
        dateFormat: 'm/d/Y',
        appendTo: targetElement,
        disable: [
          date => {
            let end = new Date()
            end.setDate(end.getDate() + 14) // today + 13 = 14 days total

            const d = new Date(date)

            if (d.getDay() === 0 || d.getDay() === 6) return true

            return d <= end
          }
        ],
        locale: {
          // firstDayOfWeek: 1
        },
        onReady (_selectedDates, _dateStr, instance) {
          const first = findFirstEnabledDate(instance, new Date(), 30)
          if (first) instance.jumpToDate(first, false) // first view = first available date
        },
        onChange: function (selectedDates, dateStr, instance) {
          const withoutDateText = document.querySelector(
            '[js-delivery-date-input-opener] [js-text-without-date]'
          )
          const withDateText = document.querySelector(
            '[js-delivery-date-input-opener] [js-text-with-date]'
          )
          if (withoutDateText && withDateText) {
            withoutDateText.classList.add('d-none')
            withDateText.classList.remove('d-none')
            const date = new Date(dateStr)
            withDateText.innerHTML = String(
              withDateText.getAttribute('data-template')
            ).replaceAll('((date))', `${date.getWeek()}/${date.getWeek() + 1}`)
          }
        }
      })
      return element
    }

    var openAccordion = container => {
      if (!container) return
      container.classList.add('open')
      const contentWrapper = container.querySelector('[js-accordion-content]')
      if (!contentWrapper) return
      contentWrapper.style.maxHeight = contentWrapper.scrollHeight + 'px'
    }

    var closeAccordion = container => {
      if (!container) return
      container.classList.remove('open')
      const contentWrapper = container.querySelector('[js-accordion-content]')
      if (!contentWrapper) return
      contentWrapper.style.maxHeight = 0 + 'px'
    }

    var initialize = () => {
      document.addEventListener('click', e => {
        if (
          e.target.closest('[js-delivery-date-wrapper] [js-accordion-header]')
        ) {
          const container = e.target.closest('[js-delivery-date-wrapper]')
          if (container.classList.contains('open')) {
            closeAccordion(container)
          } else {
            openAccordion(container)
          }
        }
        if (e.target.closest('[js-delivery-date-input-opener]')) {
          const element = document.querySelector('#cart_delivery_time')
          if (element) {
            let datePicker = null
            if (element._flatpickr) {
              datePicker = element._flatpickr
            } else {
              datePicker = disableUnavailableDates(element)
            }
            if (e.target.closest('.clear-icon')) {
              datePicker?.clear()
              element.value = EMPTY_DATE_VALUE
              const withoutDateText = document.querySelector(
                '[js-delivery-date-input-opener] [js-text-without-date]'
              )
              const withDateText = document.querySelector(
                '[js-delivery-date-input-opener] [js-text-with-date]'
              )
              if (withoutDateText && withDateText) {
                withoutDateText.classList.remove('d-none')
                withDateText.classList.add('d-none')
              }
            } else {
              if (datePicker.isOpen === false) {
                datePicker?.open()
              }
            }
          }
        }
      })

      document.addEventListener(
        'submit',
        async e => {
          const form = e.target
          if (!form.closest('xo-cart-mini')) return

          const submitter = e.submitter
          if (!submitter?.matches('[js-submit-cart-drawer]')) return

          e.preventDefault()

          try {
            const [attr_name, attr_value] = getDateInputValue()
            if (attr_name && attr_value) {
              await applyPropertyToAllLines(attr_name, attr_value)
            }
          } catch (error) {}

          form.submit()
        },
        true
      )
    }
    return {
      init: initialize
    }
  })()

  var ProductItemApp = (() => {
    var initialize = () => {
      document
        .querySelectorAll('.bd-product-item .color-option-list .more-less-icon')
        .forEach(element => {
          element.addEventListener('click', () => {
            element.closest('.color-option-list').classList.toggle('open')
            if (element.closest('[data-flickity]')) {
              const flickity = new Flickity(element.closest('[data-flickity]'))
              flickity.resize()
            }
          })
        })
    }
    return {
      init: initialize
    }
  })()

  var TabApp = (() => {
    var open = (container, data_index) => {
      if (!container || !data_index) return
      container
        .querySelectorAll('[js-tab-header], [js-tab-body]')
        .forEach(element => {
          element.classList.remove('active')
          if (element.getAttribute('data-index') === String(data_index)) {
            element.classList.add('active')
            if (element.querySelector('[data-flickity]')) {
              const flickity = new Flickity(
                element.querySelector('[data-flickity]')
              )
              flickity.resize()
            }
          }
        })
    }
    var initialize = () => {
      document.querySelectorAll('[js-tab] [js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-tab]'), element.getAttribute('data-index'))
        })
      })
    }
    return {
      init: initialize
    }
  })()

  var CartOrderDateApp = (() => {
    var initialize = () => {
      document.querySelectorAll('[js-order-note-date]').forEach(element => {
        element.addEventListener('change', () => {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              note: `Date: ${element.value}`
            })
          })
            .then(response => response.json())
            .then(data => {
              console.log('Cart note updated successfully:', data)
              // Optional: Show success message to user
            })
            .catch(error => {
              console.error('Error updating cart note:', error)
              // Optional: Show error message to user
            })
        })
      })
    }
    return {
      init: initialize
    }
  })()

  // var DemensionSizeDataApp = (() => {
  // 	var initialize = () => {
  // 		// const setSecondSlide = () => {
  // 		// 	// Try different selectors for thumbnails
  // 		// 	const secondThumb = document.querySelector('xo-carousel-slide.xo-product-info-media-carousel__thumb-slide[data-index="2"]')

  // 		// 	if (secondThumb) {
  // 		// 		// Find the actual clickable element (button, link, or image)
  // 		// 		const clickTarget = secondThumb.querySelector('button, a, img') || secondThumb;

  // 		// 		// Create proper touch event
  // 		// 		const touchEvent = new Event('touchend', { bubbles: true, cancelable: true });
  // 		// 		const clickEvent = new Event('click', { bubbles: true, cancelable: true });

  // 		// 		// Trigger both touch and click
  // 		// 		clickTarget.dispatchEvent(touchEvent);
  // 		// 		clickTarget.dispatchEvent(clickEvent);

  // 		// 		// Force click as backup
  // 		// 		clickTarget.click();
  // 		// 	}
  //       	// };

  // 		// setTimeout(setSecondSlide, 2000);

  // 		// Slide change listener
  // 		document.querySelectorAll('xo-carousel').forEach(element => {
  // 			element.addEventListener('slide:change', e => {
  // 				// Update measurement info
  // 				document.querySelectorAll('.product-measurement-info-wrapper').forEach(sizeItem => {
  // 					if (sizeItem.getAttribute('data-demension-index') === String(e.detail.index + 1)) {
  // 						sizeItem.classList.add('active');
  // 					} else {
  // 						sizeItem.classList.remove('active');
  // 					}
  // 				});

  // 				// Update slider counter
  // 				const imagez_slide_index = document.querySelectorAll('xo-carousel-slide')[e.detail.index].getAttribute("aria-label");
  // 				const slider_counter = document.querySelector('[data-slider-counter-index]');
  // 				if (imagez_slide_index && slider_counter) {
  // 					slider_counter.innerHTML = imagez_slide_index;
  // 				}

  // 				// Update image description
  // 				const descElement = document.querySelector('[js-media-image-desc]');
  // 				const image_desc = descElement?.getAttribute("data-image-desc");
  // 				if (image_desc && descElement) {
  // 					const image_desc_array = image_desc.split('\n');
  // 					if (image_desc_array[e.detail.index]) {
  // 						descElement.style.display = 'block';
  // 						descElement.innerHTML = image_desc_array[e.detail.index];
  // 					} else {
  // 						descElement.style.display = 'none';
  // 					}
  // 				}
  // 			});
  // 		});
  // 	};

  // 	return {
  // 		init: initialize
  // 	};
  // })();

  var DemensionSizeDataApp = (() => {
    var updateSlideContent = index => {
      // Update measurement info
      document
        .querySelectorAll('.product-measurement-info-wrapper')
        .forEach(sizeItem => {
          if (
            sizeItem.getAttribute('data-demension-index') === String(index + 1)
          ) {
            sizeItem.classList.add('active')
          } else {
            sizeItem.classList.remove('active')
          }
        })

      // Update slider counter
      const slides = document.querySelectorAll('xo-carousel-slide')
      if (slides[index]) {
        const imagez_slide_index = slides[index].getAttribute('aria-label')
        const slider_counter = document.querySelector(
          '[data-slider-counter-index]'
        )
        if (imagez_slide_index && slider_counter) {
          slider_counter.innerHTML = imagez_slide_index
        }
      }

      // Update image description
      const descElement = document.querySelector('[js-media-image-desc]')
      const image_desc = descElement?.getAttribute('data-image-desc')
      if (image_desc && descElement) {
        const image_desc_array = image_desc.split('\n')
        if (image_desc_array[index]) {
          descElement.style.display = 'block'
          descElement.innerHTML = image_desc_array[index]
        } else {
          descElement.style.display = 'none'
        }
      }
    }

    var initialize = () => {
      // Slide change listener (for drag/swipe)
      document.querySelectorAll('xo-carousel').forEach(element => {
        element.addEventListener('slide:change', e => {
          updateSlideContent(e.detail.index)
        })
      })

      // Add click listeners to prev/next buttons
      document
        .querySelectorAll('.slider-prev-btn-wrapper, xo-carousel-prev')
        .forEach(prevBtn => {
          prevBtn.addEventListener('click', () => {
            // Small delay to let the carousel update
            setTimeout(() => {
              const carousel = document.querySelector('xo-carousel')
              const activeSlide = carousel?.querySelector(
                '[xo-active], [xo-visible]'
              )

              if (activeSlide) {
                const allSlides = Array.from(
                  carousel.querySelectorAll('xo-carousel-slide')
                )
                const currentIndex = allSlides.indexOf(activeSlide)
                updateSlideContent(currentIndex)
              }
            }, 100)
          })
        })

      document
        .querySelectorAll('.slider-next-btn-wrapper, xo-carousel-next')
        .forEach(nextBtn => {
          nextBtn.addEventListener('click', () => {
            // Small delay to let the carousel update
            setTimeout(() => {
              const carousel = document.querySelector('xo-carousel')
              const activeSlide = carousel?.querySelector(
                '[xo-active], [xo-visible]'
              )
              if (activeSlide) {
                const allSlides = Array.from(
                  carousel.querySelectorAll('xo-carousel-slide')
                )
                const currentIndex = allSlides.indexOf(activeSlide)
                updateSlideContent(currentIndex)
              }
            }, 100)
          })
        })
    }

    return {
      init: initialize
    }
  })()

  var VideoMuteControlWrapperApp = (() => {
    var muteVideos = (container, mute = true) => {
      if (!container) return
      container.querySelectorAll('video').forEach(element => {
        element.muted = mute
        if (mute) element.volume = 0
      })
    }
    var initialize = () => {
      document
        .querySelectorAll('[js-video-mute-control-wrapper]')
        .forEach(element => {
          muteVideos(element, element.getAttribute('data-mute') === 'true')
        })
    }
    return {
      init: initialize
    }
  })()

  var ConnectedProductPickerApp = (() => {
    var show = (container, parent_index) => {
      if (!container) return
      const index_array = String(parent_index)
        .split('-')
        .reduce((acc, num, index, arr) => {
          acc.push(arr.slice(0, index + 1).join('-'))
          return acc
        }, [])
      let i = 0
      let temp_index
      container.querySelectorAll('[data-parent-index]').forEach(element => {
        let subindex = null
        if (i < index_array.length) {
          temp_index = index_array[i]
          try {
            subindex = String(parent_index)
              .replace(temp_index, '')
              .split('-')[1]
          } catch (error) {}
        } else {
          temp_index = `${temp_index}-1`
        }
        if (!subindex) subindex = '1'
        if (element.getAttribute('data-parent-index') === temp_index) {
          element.classList.add('active')
          const flickity = element.querySelector(
            '.option-value-list-wrapper.flickity-enabled'
          )
          if (flickity) {
            const f = new Flickity(flickity)
            f.resize()
          }
          element.querySelectorAll('[data-index]').forEach(subelement => {
            if (subelement.getAttribute('data-index') === String(subindex)) {
              subelement.classList.add('active')
            } else {
              subelement.classList.remove('active')
            }
          })
          const connectedProduct = element.querySelector('.connected-product')
          if (
            connectedProduct &&
            !element.querySelector('.connected-product.active')
          )
            connectedProduct.click()
          i++
        } else {
          element.classList.remove('active')
        }
      })
    }
    var initEachContainer = container => {
      if (!container) return
      container
        .querySelectorAll('[data-parent-index] [js-option-picker][data-index]')
        .forEach(element => {
          element.addEventListener('click', () => {
            show(
              container,
              `${element
                .closest('[data-parent-index]')
                .getAttribute('data-parent-index')}-${element.getAttribute(
                'data-index'
              )}`
            )
          })
        })
      const activeProduct = container.querySelector(
        '[data-parent-index] .connected-product.active'
      )
      if (activeProduct) {
        show(
          container,
          activeProduct
            .closest('[data-parent-index]')
            .getAttribute('data-parent-index')
        )
      }
    }
    var initialize = () => {
      document
        .querySelectorAll('[js-product-connected-products-container]')
        .forEach(container => {
          initEachContainer(container)
        })
    }
    return {
      init: initialize
    }
  })()
  var ProductInfoCollapseWrapperApp = (() => {
    var initialize = () => {
      if (document.querySelectorAll('.xo-product-info-content__collapse')[0]) {
        document.querySelectorAll(
          '.xo-product-info-content__collapse'
        )[0].style.marginTop = '20px'
      }
      if (
        document.querySelectorAll('.xo-product-info-content__collapse')[
          length - 1
        ]
      ) {
        document.querySelectorAll('.xo-product-info-content__collapse')[
          length - 1
        ].style.marginBottom = '0px'
      }
    }
    return {
      init: initialize
    }
  })()
})();

(() => {
  'use strict';

  // const VARIANT_NRW     = 53288903311698;
  const VARIANT_ANFRAGE = 53288903344466;

  let NRW_RANGES = [
    [32000,32999],[33000,33999],[34000,34999],[37000,37999],
    [40000,42999],[44000,48999],[50000,51999],[52000,53999],
    [57000,57999],[58000,59999]
  ];

  for (let i = 0; i < window.allowedArray.length; i ++) {
    NRW_RANGES.push( window.allowedArray[i] );
  }

  let NRW_SINGLE_LIST = [];
  for (let i = 0; i < window.allowedPlzStrList.length; i ++) {
    NRW_SINGLE_LIST.push( Number(window.allowedPlzStrList[i]) );
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }
  console.log("Here is the montageservice variants", window.montageserviceVariants);

  function isNRW(plz) {
    const n = parseInt(plz, 10);
    if (isNaN(n) || plz.length !== 5) return false;
    // if ( NRW_RANGES.some(([a, b]) => n >= a && n <= b) || NRW_SINGLE_LIST.some((a) => n == a) ) return true;
    // return NRW_RANGES.some(([a, b]) => n >= a && n <= b);
    else if (window.is_allowAllPLZs == true) {
      return true;
    } else {
      if ( NRW_RANGES.some(([a, b]) => n >= a && n <= b) || NRW_SINGLE_LIST.some((a) => n == a) ) return true;
      else return false;
    }
  }

  // Same section IDs the theme uses so Shopify returns drawer + icon HTML
  function getSectionIds() {
    const cartMini = document.querySelector('xo-cart-mini');
    const cartMiniId = cartMini ? cartMini.id : null;
    if (cartMiniId) return [cartMiniId, 'cart-icon-bubble'];
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  // Update theme cart store so mini-cart and header icon refresh (same as adding a normal product)
  function pushCartSections(sections, itemCount) {
    if (typeof window.xoStore !== 'undefined' && sections && Object.keys(sections).length) {
      window.xoStore.set('xo-cart', function(prev) {
        return Object.assign({}, prev, { sections: sections, size: itemCount != null ? itemCount : (prev.size || 0) + 1 });
      })('xo-cart/updateCartSections');
    }
  }

  async function cartAdd(variantId, properties) {
    const sectionIds = getSectionIds();
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    console.log("Here is the card function....1");
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: properties || {} }],
        sections: sectionIds,
        section_url: window.location.pathname
      })
    });
    console.log("Here is the card function....1");
    if (!res.ok) {
      const err = await res.json().catch(function() { return {}; });
      throw new Error(err.description || err.message || 'cart/add.js failed: ' + res.status);
    }
    const data = await res.json();
    if (data.sections) pushCartSections(data.sections, data.item_count);
    return data;
  }

  async function cartRemoveByVariant(variantId) {
    const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart    = await cartRes.json();
    const item    = cart.items.find(function(i) { return i.variant_id === variantId; });
    if (!item) return;
    const sectionIds = getSectionIds();
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: 0,
        sections: sectionIds,
        section_url: window.location.pathname
      })
    });
    if (!res.ok) throw new Error('cart/change.js failed: ' + res.status);
    const data = await res.json();
    if (data.sections) pushCartSections(data.sections, data.item_count);
    return data;
  }

  function init() {
    const wrapper = document.getElementById('livn-montage-block');
    if (!wrapper) return;
    if (wrapper.dataset.livnInit === '1') return;
    wrapper.dataset.livnInit = '1';

    const trigger      = wrapper.querySelector('.livn-accordion__trigger');
    const body         = wrapper.querySelector('#livn-montage-body');
    const plzSection   = wrapper.querySelector('#livn-plz-section');
    const plzInput     = wrapper.querySelector('#livn-plz-input');
    const plzBtn       = wrapper.querySelector('#livn-plz-btn');
    const stateAvail   = wrapper.querySelector('#livn-state-available');
    const stateUnavail = wrapper.querySelector('#livn-state-unavailable');
    const addedNRW     = wrapper.querySelector('#livn-added-nrw');
    const addedAnfrage = wrapper.querySelector('#livn-added-anfrage');
    const btnAddNRW    = wrapper.querySelector('#livn-btn-add-nrw');
    const btnAddAnfr   = wrapper.querySelector('#livn-btn-add-anfrage');
    const requestCb    = wrapper.querySelector('#livn-request-checkbox');
    const requestLabel = wrapper.querySelector('#livn-request-label');

    console.log("This is the service product variants", window.montageserviceVariants);
    let montageProductVariantId = '';
    // const montageProductVariantId = document.querySelector('#cart-montageservice-product-variant-id')?.value;

    // ── Accordion ──────────────────────────────────────────────
    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        body.removeAttribute('hidden');
        setTimeout(() => body.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 50);
      } else {
        body.setAttribute('hidden', '');
      }
    });

    // ── PLZ ────────────────────────────────────────────────────
    function resetStates() {
      stateAvail.hidden   = true;
      stateUnavail.hidden = true;
    }
    plzInput.addEventListener('input', resetStates);
    plzInput.addEventListener('keydown', e => { if (e.key === 'Enter') checkPLZ(); });
    plzBtn.addEventListener('click', checkPLZ);

    function checkPLZ() {
      const plz = plzInput.value.trim().replace(/\D/g, '');
      if (plz.length !== 5) {
        plzInput.classList.add('livn-error');
        setTimeout(() => plzInput.classList.remove('livn-error'), 600);
        return;
      }
      plzBtn.classList.add('livn-loading');
      plzBtn.disabled = true;
      resetStates();
      setTimeout(() => {
        plzBtn.classList.remove('livn-loading');
        plzBtn.disabled = false;
        if (isNRW(plz)) { stateAvail.hidden = false; }
        else             { stateUnavail.hidden = false; }
      }, 800);
    }

    // ── Add NRW ────────────────────────────────────────────────
    btnAddNRW.addEventListener('click', async () => {
      btnAddNRW.classList.add('livn-loading');
      btnAddNRW.disabled = true;
      try {
        const cart = await fetchCart();
        console.log("items of the cart", cart.items);
        const alreadyInCart = cart.items.some(item =>
          item.properties?._is_montageservice === true
        );

        if (alreadyInCart) {
          console.log('Montageservice product is already in cart — skipping.');
          return;
        }

        let product_type = '';
        for (let i = 0; i < cart.items.length; i ++) {
          let item = cart.items[i];
          if (item.properties?._is_montageservice === true) continue; // only look at the non-service product

          const title = String(item.product_title)?.toLowerCase();
          console.log("This is the product title", title);

          if (title.includes("cube")) {
            // Cube 55 has its own dedicated variant; Cube 25/28 -> lower tier, Cube 40 -> higher tier (grouped with Cottage)
            if (title.includes("55")) {
              product_type = 'cube_55';
            } else if (title.includes("25") || title.includes("28")) {
              product_type = 'cube_25_28';
            } else {
              product_type = 'cube_40_cottage';
            }
          } else if (title.includes("cottage")) {
            product_type = 'cube_40_cottage';
          }

          if (product_type) {
            montageProductVariantId = window.montageserviceVariants[product_type];
            console.log("This is the montageservice variant", montageProductVariantId);
            break;
          }
        }

        if (!montageProductVariantId) {
          console.log("There is no montageservice product variant", montageProductVariantId);
          return;
        }

        await cartAdd(montageProductVariantId, {
          _is_montageservice: true,
          '_montageservice': 'Gebucht – NRW' 
        });
        plzSection.classList.add('livn-hidden');
        addedNRW.classList.remove('livn-hidden');
        setTriggerState('added');
      } catch (err) {
        console.error('[LIVN] Add NRW failed:', err);
        alert('Fehler beim Hinzufügen. Bitte versuche es erneut.');
      } finally {
        btnAddNRW.classList.remove('livn-loading');
        btnAddNRW.disabled = false;
      }
    });

    // ── Checkbox ───────────────────────────────────────────────
    function toggleCheckbox() {
      const checked = requestCb.getAttribute('aria-checked') === 'true';
      requestCb.setAttribute('aria-checked', String(!checked));
      btnAddAnfr.classList.toggle('livn-hidden', checked);
    }
    requestLabel.addEventListener('click', toggleCheckbox);
    requestCb.addEventListener('keydown', e => {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggleCheckbox(); }
    });

    // ── Add Anfrage ────────────────────────────────────────────
    btnAddAnfr.addEventListener('click', async () => {
      const plz = plzInput.value.trim() || 'unbekannt';
      btnAddAnfr.classList.add('livn-loading');
      btnAddAnfr.disabled = true;
      try {
        const cart = await fetchCart();
        const alreadyInCart = cart.items.some(item =>
          item.properties?._is_montageservice === true
        );

        if (alreadyInCart) {
          console.log('Montageservice product is already in cart — skipping.');
          return;
        }
        
        await cartAdd(VARIANT_ANFRAGE, {
          _is_montageservice: true,
          '_montageservice':      'Anfrage – PLZ ' + plz,
          '_montageservice_info': 'Kunde wünscht Montage, nicht verfügbar in PLZ ' + plz
        });
        plzSection.classList.add('livn-hidden');
        addedAnfrage.classList.remove('livn-hidden');
        setTriggerState('anfrage');
      } catch (err) {
        console.error('[LIVN] Add Anfrage failed:', err);
        alert('Fehler beim Speichern. Bitte versuche es erneut.');
      } finally {
        btnAddAnfr.classList.remove('livn-loading');
        btnAddAnfr.disabled = false;
      }
    });

    // ── Remove ─────────────────────────────────────────────────
    wrapper.querySelectorAll('.livn-btn-remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        const type      = btn.dataset.remove;
        // const variantId = type === 'nrw' ? VARIANT_NRW : VARIANT_ANFRAGE;
        const cart = await fetchCart();

        for (let i = 0; i < cart.items.length; i ++) {
          let item = cart.items[i];
          console.log("This is the product title", String(item.product_title)?.toLowerCase());
          if (item.properties?._is_montageservice === true) {
            montageProductVariantId = item.variant_id;
            console.log("This is the montageservice product variant ID", montageProductVariantId);
            break;
          }
        }

        const variantId = type === 'nrw' ? montageProductVariantId : VARIANT_ANFRAGE;
        btn.disabled    = true;
        try {
          await cartRemoveByVariant(variantId);

          // Hide added box
          if (type === 'nrw') { addedNRW.classList.add('livn-hidden'); }
          else                { addedAnfrage.classList.add('livn-hidden'); }

          // Full reset of PLZ section
          plzSection.classList.remove('livn-hidden');
          plzInput.value = '';
          stateAvail.hidden   = true;
          stateUnavail.hidden = true;
          requestCb.setAttribute('aria-checked', 'false');
          btnAddAnfr.classList.add('livn-hidden');

          // Reset trigger
          setTriggerState('default');

          // Keep accordion open so user sees the reset form
          body.removeAttribute('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        } catch (err) {
          console.error('[LIVN] Remove failed:', err);
        } finally {
          btn.disabled = false;
        }
      });
    });

    // ── Trigger state helper ───────────────────────────────────
    function setTriggerState(state) {
      const iconWrap = trigger.querySelector('.livn-accordion__icon-wrap');
      const title    = trigger.querySelector('.livn-accordion__title');
      const subtitle = trigger.querySelector('.livn-accordion__subtitle');
      if (state === 'added') {
        iconWrap.textContent = '✅';
        title.textContent    = 'Montageservice hinzugefügt';
        subtitle.textContent = 'Professioneller Aufbau vor Ort';
        trigger.classList.add('livn-accordion__trigger--active');
      } else if (state === 'anfrage') {
        iconWrap.textContent = '📋';
        title.textContent    = 'Montage-Anfrage hinterlegt';
        subtitle.textContent = 'Wir melden uns nach der Bestellung';
        trigger.classList.add('livn-accordion__trigger--active');
      } else {
        iconWrap.textContent = '🔧';
        title.textContent    = 'Montageservice hinzufügen';
        subtitle.textContent = 'Professioneller Aufbau vor Ort';
        trigger.classList.remove('livn-accordion__trigger--active');
      }
    }
  }

  // Re-init after theme updates cart drawer (theme uses window.cartSubscribe for xo-cart store)
  function setupCartReinit() {
    if (typeof window.cartSubscribe === 'function') {
      window.cartSubscribe(function() {
        setTimeout(init, 0);
      });
      return;
    }
    var tries = 0;
    function wait() {
      if (typeof window.cartSubscribe === 'function') {
        window.cartSubscribe(function() { setTimeout(init, 0); });
        return;
      }
      if (tries++ < 50) setTimeout(wait, 100);
    }
    setTimeout(wait, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      setupCartReinit();
    });
  } else {
    init();
    setupCartReinit();
  }

})();
